import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { updateNotes } from "@/Services/TherapyApi/ClinicalHistory";
import NotesTransformer, { type NotesTransformerType } from "@/Modules/Transformers/ClinicalHistory/Notes";

import useClinicalHistoryStore from "@/Modules/ClinicalHistory/Store";
import useAppStore from "@/Modules/App/Store";
import useCustomerStore from "@/Modules/Customers/Store";

import { hasValue } from "@/Utils/Objects";

async function updateNotesAH(noteId: string, notes: string) {
  const appStore = useAppStore();
  const clinicalHistoryStore = useClinicalHistoryStore();
  const customerStore = useCustomerStore();

  if (!hasValue(customerStore.getCurrentCustomer)) return undefined;

  clinicalHistoryStore.isLoadingNotes = true;

  try {
    const notesApi = await updateNotes(customerStore.getCurrentCustomer.id, noteId, notes);
    const notesTransformer: NotesTransformerType = NotesTransformer;
    const notesDomain = notesTransformer.toDomain(notesApi);

    clinicalHistoryStore.notes = notesDomain;

    appStore.showSnackbar({
      message: "user.settings.customer.clinical_history.notes.saved_notification",
      type: NotificationType.SUCCESS,
    });
  } catch (error: unknown) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });
  } finally {
    clinicalHistoryStore.isLoadingNotes = false;
  }
}

export default updateNotesAH;
